// 동기화 E2E: 금고 스냅샷을 복구 키로 암호화해 서버(R2)에 올린다. 서버는 암호문만 보관하고 못 연다(goals.md 원칙1).
// 복구 키는 가입 때 보여 준 12단어. 기기 비밀번호와 별개라, 다른 기기에서 그 키로 복원한다.
import { deriveKey, encryptJSON, decryptJSON, randomBytes, toB64, fromB64 } from './crypto'
import { api } from './api'
import { useVaultStore } from '../stores/vault'

const WS = 'default' // v1: 작업 공간 하나
interface SyncBlob { v: number; salt: string; iv: string; ct: string }

function snapshot() {
  const v = useVaultStore()
  return { v: 1, people: v.people, depts: v.depts, companies: v.companies, relations: v.relations, entries: v.entries }
}

export async function backup(recovery: string): Promise<{ rev: number; bytes: number }> {
  const salt = randomBytes(16)
  const key = await deriveKey(recovery, salt)
  const cipher = await encryptJSON(key, snapshot())
  const blob: SyncBlob = { v: 1, salt: toB64(salt), ...cipher }
  return api('PUT', `/sync/${WS}`, blob)
}

export async function restore(recovery: string): Promise<{ entries: number; people: number }> {
  const blob = await api<SyncBlob>('GET', `/sync/${WS}`)
  const key = await deriveKey(recovery, fromB64(blob.salt))
  const data = await decryptJSON<any>(key, { iv: blob.iv, ct: blob.ct }) // 키가 틀리면 여기서 실패(AES-GCM 인증)
  await useVaultStore().replaceAll(data)
  return { entries: (data.entries || []).length, people: (data.people || []).length }
}

export async function lastBackup(): Promise<{ rev: number; bytes: number; updated_at: string } | null> {
  try {
    const m = await api<{ manifest: any[] }>('GET', '/sync/manifest')
    return m.manifest?.find((x) => x.workspace_key === WS) ?? null
  } catch { return null }
}
